export default "__VITE_PUBLIC_ASSET__94b72979__"